import React from 'react'
import { Plan } from '../../types'
import { PlanCompliance, PlanComplianceData } from '../types'

import HoverTooltip from '../../../../../components/HoverTooltip'

type Props = {
    positionCount: number | string
    sum: number | string
    mspSum: number
    percentMspSum: number
    plan?: Plan
    planVersion: string | null
    loadPlan: boolean
    planVersionDiff: string
    planCompliance: PlanCompliance | null | undefined
    onUpdate: (regNumber: number) => void
    theme: string
    organizationCompliance: boolean | undefined
    isUserRoleName: string
}

const PlanPositionsHeader: React.FC<Props> = ({
    positionCount,
    sum,
    mspSum,
    percentMspSum,
    plan,
    planVersion,
    loadPlan,
    planVersionDiff,
    planCompliance,
    onUpdate,
    theme,
    organizationCompliance,
    isUserRoleName,
}) => {
    return (
        <div className=" h-24 mx-6 flex flex-row gap-x-5 ">
            <div className="w-52 my-auto content-center border-r border-r-[#b8b8b8] dark:border-r-[#2A282B]">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                    Реестровый номер
                </div>
                <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                    {loadPlan ? (
                        (plan?.registration_number ?? 'Нет данных')
                    ) : (
                        <svg
                            className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                            ></path>
                        </svg>
                    )}
                </div>
            </div>
            <div className="w-52 my-auto content-center border-r border-r-[#b8b8b8] dark:border-r-[#2A282B]">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                    Период планирования
                </div>
                <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                    {loadPlan ? (
                        (plan?.start_date.split('-')[0] ?? 'Нет данных')
                    ) : (
                        <svg
                            className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                            ></path>
                        </svg>
                    )}
                </div>
            </div>
            <div className="w-52 my-auto content-center border-r border-r-[#b8b8b8] dark:border-r-[#2A282B]">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                    Количество позиций
                </div>
                <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                    {loadPlan ? (
                        positionCount
                    ) : (
                        <svg
                            className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                            ></path>
                        </svg>
                    )}
                </div>
            </div>
            <div className="w-52 my-auto content-center border-r border-r-[#b8b8b8] dark:border-r-[#2A282B]">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                    Запланировано закупок
                </div>
                <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                    {loadPlan ? (
                        Number(sum).toLocaleString('ru-RU', {
                            minimumFractionDigits: 2,
                        }) + ' ₽'
                    ) : (
                        <svg
                            className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                            ></path>
                        </svg>
                    )}
                </div>
            </div>
            <div className="w-52 my-auto content-center border-r border-r-[#b8b8b8] dark:border-r-[#2A282B]">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                    Запланировано закупок у МСП
                </div>
                <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                    {loadPlan ? (
                        Number(mspSum).toLocaleString('ru-RU', {
                            minimumFractionDigits: 2,
                        }) + ` ₽ (${percentMspSum}%)`
                    ) : (
                        <svg
                            className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                            ></path>
                        </svg>
                    )}
                </div>
            </div>
            <div className="flex flex-row w-52 my-auto items-center justify-start border-r border-r-[#b8b8b8] dark:border-r-[#2A282B] gap-3">
                <div className="flex flex-col w-fit my-auto items-start justify-start">
                    <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] text-left">
                        Версия плана
                    </div>
                    <div className="text-xs text-[#181818] dark:text-[#FFFFFF] text-left">
                        {loadPlan ? (
                            planVersion
                        ) : (
                            <svg
                                className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                ></path>
                            </svg>
                        )}
                    </div>
                </div>
                <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">
                    {planVersionDiff != '' ? (
                        <HoverTooltip
                            tooltipText={`Обновите план. Версия плана в ЕИС: ${planVersionDiff}`}
                        >
                            <button
                                onClick={() =>
                                    onUpdate(
                                        plan?.registration_number
                                            ? plan?.registration_number
                                            : 0
                                    )
                                }
                                className="w-6 h-6 grid rounded-full place-items-center hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                            >
                                <svg
                                    className="w-5 h-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="times-circle"
                                >
                                    <path
                                        fill="#FFBF00"
                                        d="M12,14a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,14Zm0-1.5a1,1,0,0,0,1-1v-3a1,1,0,0,0-2,0v3A1,1,0,0,0,12,12.5ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"
                                    ></path>
                                </svg>
                            </button>
                        </HoverTooltip>
                    ) : (
                        ''
                    )}
                </div>
            </div>
            {organizationCompliance &&
            (isUserRoleName == 'specialist' || isUserRoleName == 'admin') ? (
                <div className="w-52 my-auto content-center border-r border-r-[#b8b8b8] dark:border-r-[#2A282B]">
                    <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                        Статус оценки
                    </div>
                    <div
                        className={`text-xs ${
                            planCompliance?.data.compliance_status
                                ? planCompliance.data.compliance_status ==
                                      'На оценке' || 'На мониторинге'
                                    ? 'text-[#e4951e] dark:text-[#FAD12E]'
                                    : planCompliance.data.compliance_status ==
                                        'Выдано положительное заключение'
                                      ? 'text-[#1c9f32] dark:text-[#049664]'
                                      : planCompliance.data.compliance_status ==
                                          'Выдано отрицательное заключение'
                                        ? 'text-[#611212] dark:text-[#C15C5C]'
                                        : 'text-[#181818] dark:text-[#FFFFFF]'
                                : 'text-[#181818] dark:text-[#FFFFFF]'
                        }`}
                    >
                        {loadPlan ? (
                            planCompliance?.data.compliance_status ? (
                                planCompliance.data.compliance_status
                            ) : (
                                '-'
                            )
                        ) : (
                            <svg
                                className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                ></path>
                            </svg>
                        )}
                    </div>
                </div>
            ) : (
                ''
            )}

            {/* <div className="w-52 my-auto content-center ">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                    Закупки исключаемые у МСП
                </div>
                <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">0,00 ₽</div>
            </div> */}
        </div>
    )
}

export default PlanPositionsHeader
